export class ChartService  {
    private _chart:any;

    constructor() {
        this._chart = window['Chart'] as any;
        if (!this._chart) {
            console.error("Cannot find reference to Chart.js library.  Check script path inclusion");
            return;
        }
        this.registerPlugins();
    }

    drawChart(targetElement:Element, data, configOptions) {
        var element = targetElement as HTMLCanvasElement;
        var ctx = element.getContext("2d");
        // TODO: stephen need a way of injecting this instead of grabbing a global script.
        return new this._chart(ctx, {
            type: "bar",
            data: data,
            options: configOptions
        });
    }
    // TODO: stephen need to typedef this.
    destroyChart(chart:any) {
        if (chart && chart.destroy) {
            // chart destroy doesn't seem to actually clear the canvas element
            if (chart.clear) {
                chart.clear();
            }
            chart.destroy();
        }
    }

    registerPlugins() {
        let Chart = this._chart;
        Chart.plugins.register({
        afterDraw: function(chartInstance) {
            if (chartInstance.config.options.showDatapoints) {
            var helpers = Chart.helpers;
            var ctx = chartInstance.chart.ctx;
            var fontColor = helpers.getValueOrDefault(chartInstance.config.options.showDatapoints.fontColor, chartInstance.config.options.defaultFontColor);

            // render the value of the chart above the bar
            let fontSize = chartInstance.config.options.dataPointFontSize ? chartInstance.config.options.dataPointFontSize : Chart.defaults.global.defaultFontSize;
            ctx.font = Chart.helpers.fontString(fontSize, 'bold', Chart.defaults.global.defaultFontFamily);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            ctx.fillStyle = fontColor;

            // chartInstance.data.datasets.forEach(function (dataset) {
            //     for (var i = 0; i < dataset.data.length; i++) {
            //     var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
            //     var scaleMax = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._yScale.maxHeight;
            //     var yPos = (scaleMax - model.y) / scaleMax >= 0.93 ? model.y + 20 : model.y - 5;
            //     ctx.fillText(dataset.data[i], model.x, yPos);
            //     }
            // });
            }
        }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/assessment-charts/services/chart.service.ts